import React,{useState} from 'react'
import './NavBar.css'
import {AiOutlineHeart} from 'react-icons/ai'
import {BsBagCheck} from 'react-icons/bs'
import {AiOutlineUser} from 'react-icons/ai'
import {CiLogin} from 'react-icons/ci'
import {CiLogout} from 'react-icons/ci'
import { Link } from 'react-router-dom'
import { useAuth0 } from "@auth0/auth0-react";



const NavBar = () => {
    
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

   const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
        
  return (
     <div className= 'nav_container' >
        <div className='logo'>
            <img src="./logo-no-background.png" alt="logo" width="500" height="500"></img>
           
        </div>

        <div className='mission'>
            <h2>Dress to your style</h2>
            <h3>We are located in Nairobi.<br/>We have our finger on the pulse of today's <br/>most popular fashions.</h3>
        </div>
        
        
        <div className='icons'>
            {
                isAuthenticated &&(
            <div className='account'>
                <div className='user_icon'>
                     <AiOutlineUser/>
                </div>
                <p>Hello, {user.nickname}</p>
            </div>
                )
            }
            <div className='navs'>
                 <ul>
                     <li>
                        <Link to='/' className='link'>Home</Link>
                     </li>

                     <li>
                        <Link to='/about' className='link'>About Us</Link>
                     </li>

                     <li className="dropdown-li">
                      <Link to='/shop'className='link' onClick={toggleDropdown} >
                        Shop  
                        <span class="dropdown-arrow">&#9660;</span>
                      </Link>
                      
                      {isDropdownOpen && (
                          <div className="dropdown-content">
                                  {/* links for dropdown items */}
                                <div className="dropdown-box">
                                    <Link to="/shop" className="dropdown-link">ALL </Link>
                                     <Link to="/shop/shop-by-categories" className="dropdown-link"> SHOP BY CATEGORIES </Link>
                                     <Link to="/shop/on-offer" className="dropdown-link">ON OFFER</Link>
                                     
                                </div>
                          </div>
                      )}

                     </li> 

                     <li>
                     <Link to='/contact' className='link'>Contact Us</Link>
                     </li>
                 </ul>

                 <div className='auth'>
                    {
                        isAuthenticated?
                        <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}> <CiLogout /> </button>:
                        <button onClick={() => loginWithRedirect()}><CiLogin /></button>
                    }
                     
                    
                    
                 </div>
            </div>
            
            
            <div className='cart_icon'>
                <Link to='/' className='link' ><AiOutlineHeart/></Link>
                <Link to='/cart' className='link' ><BsBagCheck/></Link>
                
                 
               
            </div>
            
        </div>

     </div>

  )
}

export default NavBar